import { useQuery } from '@tanstack/react-query';
import {
  fetchDoctorCenterFacilitiesMap,
  PROFILE_CENTER_FACILITIES_QUERY_KEY,
} from '@/modules/profile/functions/fetchDoctorCenterFacilities';
import type { CenterFacilitiesMap } from '@/modules/profile/utils/cheraghFacilitiesProfile';

export function useDoctorCenterFacilities(
  userId: string | number | null | undefined,
  centers: Array<{ id?: string | number } | null | undefined> | null | undefined,
  options?: { enabled?: boolean; initialData?: CenterFacilitiesMap | null },
) {
  const centerKey = Array.isArray(centers)
    ? centers
        .map(c => String(c?.id ?? ''))
        .filter(Boolean)
        .sort()
        .join(',')
    : '';
  const enabled = options?.enabled !== false && !!userId && !!centerKey;
  return useQuery(
    [PROFILE_CENTER_FACILITIES_QUERY_KEY, userId, centerKey],
    () => fetchDoctorCenterFacilitiesMap(userId!, centers),
    {
      enabled,
      initialData: options?.initialData ?? undefined,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  );
}
